import { Modal } from '@paysense-india-services/elevate-web'

const formatAmount = amount => {
  return `₹${Number(amount).toLocaleString('en-IN')}`
}

const EmiBreakdownModal = ({ data, onClose, show }) => {
  const breakdown = data?.emi_detail_bottomsheet
  const rows = breakdown?.components?.items || []
  const lastIndex = rows?.length - 1
  if (!breakdown) return null

  return (
    <Modal
      className='ew-bg-secondary'
      elevation='100'
      onCrossClick={onClose}
      show={show}
      showCross={true}>
      <div className='ew-d-flex ew-flex-column ew-gap-16'>
        <div className='ew-d-flex ew-flex-column ew-gap-4'>
          <div className='ew-typography-extra-large'>{breakdown.title}</div>
          {breakdown.subtitle ? (
            <div className='ew-typography-normal ew-color-secondary ew-fw-regular ew-mt-2'>
              {breakdown.subtitle}
            </div>
          ) : null}
        </div>

        <div className='ew-d-flex ew-flex-column ew-gap-16 ew-p-16 ew-bg-primary ew-rounded-md'>
          {rows?.map((row, index) => (
            <div
              className={`ew-d-flex ew-justify-content-between ew-align-items-center ${
                index === lastIndex ? 'ew-border-top ew-pt-12' : ''
              }`}
              key={index}>
              <span
                className={`ew-typography-small ${
                  index === lastIndex ? 'ew-fw-semi-bold' : 'ew-fw-regular'
                }`}>
                {row.title}
              </span>
              <span className='ew-typography-small ew-fw-semi-bold ew-color-primary'>
                {row.subtitle}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default EmiBreakdownModal
